module.exports = __webpack_public_path__ + "pc/img/career-swiper02.2ac46617.png";